const METRICS = {
  PAGE_PADDING: '32px',
  HEADER_CONTENT: {
    PADDING_TOP: '24px',
    PADDING_RIGHT: '48px',
    PADDING_BOTTOM: '24px',
    PADDING_LEFT: '48px'
  },
  FOOTER_CONTENT: {
    PADDING_TOP: '48px',
    PADDING_RIGHT: '48px',
    PADDING_BOTTOM: '10px',
    PADDING_LEFT: '48px'
  },
  MAIN_CONTENT: {
    PADDING_LEFT: '48px',
    PADDING_RIGHT: '48px',
    PADDING_BOTTOM: '100px',
    PADDING_TOP: '40px'
  }
};

const COLORS = {
  WHITE: '#FFFFFF',
  GRAY: '#F7F8FA',
  GRAY_2: '#F3F4F6',
  GRAY_4: '#BBC0C6',
  GRAY_6: '#868E96',
  GRAY_8: '#343A40',
  GRAY_10: '#15181A',
  SEA_BLUE: '#4667ED',
  INSTANCES_CONFIGURATION: {
    BORDER: '#c6f5fd',
    BACKGROUND: '#ffffff'
  },
  DIVIDER: {
    BORDER: '#e1e3eb'
  },
  SECTION: {
    BORDER: '#f3f4f6',
    BACKGROUND: '#ffffff'
  },
  ADD_ONS: {
    BORDER: '#f3f4f6',
    BACKGROUND: '#ffffff'
  },
  TAG: {
    BACKGROUND: '#EEF5FF',
    TEXT: '#5A6284'
  },
  TEXT: {
    SEA_BLUE: '#4667ED',
    BLACK: '#191F38',
    GRAY: '#7B7F7F',
    LIGHT_GRAY: '#5A6284',
    ERROR: '#811807'
  },
  INPUT: {
    TEXT: '#272D2D',
    BORDER: '#DCE0E9',
    HOVER: {
      BORDER: '#4667ED'
    },
    FOCUS: {
      BORDER: '#85b7d9',
      ERROR: {
        PLACEHOLDER: '#E2ACAB'
      }
    },
    ERROR: {
      TEXT: '#811807',
      PLACEHOLDER: '#EDCCCC'
    }
  },
  TEXT_AREA: {
    BORDER: '#E9ECEF',
    HOVER: {
      BORDER: '#4667ED'
    }
  },
  MESSAGE: {
    ERROR: {
      BACKGROUND: '#FAE6E3',
      TEXT: '#811807',
      SHADOW: '#f5cdc7'
    },
    SUCCESS: {
      BACKGROUND: '#e1f7f1',
      TEXT: '#055239',
      SHADOW: '#17a274'
    }
  },
  SELECT: {
    BASE: {
      BACKGROUND: '#fff6f6',
      BORDER: '#DCE0E9'
    },
    SELECTED: {
      TEXT: '#272d2d'
    },
    HOVER: { BORDER: '#4667ED' },
    ACTIVE: { BORDER: '#4667ED' },
    ERROR: {
      BORDER: '#e0b4b4',
      TEXT: '#9f3a38',
      BACKGROUND: '#fff6f6'
    }
  },
  BUTTON: {
    SEA_BLUE: {
      BACKGROUND: '#4667ED',
      TEXT: '#FFFFFF'
    },
    WHITE: {
      BACKGROUND: 'transparent',
      BORDER: '#4667ED',
      TEXT: '#4667ED'
    },
    SUCCESS: {
      BACKGROUND: '#E1F7F1',
      TEXT: '#5D737E'
    },
    INFO: {
      BACKGROUND: '#EEF5FF',
      TEXT: '#5A6284'
    },
    WARNING: {
      BACKGROUND: '#F9F0DF',
      TEXT: '#76430D'
    },
    DANGER: {
      BACKGROUND: '#FBEAEA',
      TEXT: '#831313'
    }
  },
  DATEPICKER: {
    BASE: {
      BORDER: '#DCE0E9',
      TEXT: '#272D2D'
    },
    HOVER: {
      BORDER: '#4667ED'
    },
    ERROR: {
      BACKGROUND: '#fff6f6',
      BORDER: '#e0b4b4',
      TEXT: '#9f3a38',
      HOVER: '#e0b4b4'
    }
  },
  AGREE_CHECKBOX: {
    BACKGROUND: '#ffffff'
  },
  CHECKBOX: {
    BASE: {
      BORDER: '#DCE0E9',
      TEXT: '#272D2D'
    },
    CHECKED: {
      BACKGROUND: '#4667ED'
    },
    FOCUS: {
      BORDER: '#4667ED'
    },
    HOVER: {
      BORDER: '#4667ED'
    }
  },
  FORM: {
    COLLAPSED: {
      BORDER: '#4667ED',
      TEXT: '#4667ED'
    }
  },
  ICON: {
    GRAY: '#8C8D8D',
    LIGHT_BLUE: '#C6F5FD'
  }
};

const TYPOGRAPHY = {
  BASE: {
    FONT_FAMILY: `"Open Sans", 'Helvetica Neue', Helvetica, Arial, sans-serif`
  }
};

const BREAKPOINTS = {
  MOBILE_XS: 320,
  MOBILE_SM: 480,
  MOBILE_MD: 576,
  MOBILE: 600,
  TABLET: 768,
  TABLET_LANDSCAPE: 1024,
  DESKTOP: 1800
};

export { TYPOGRAPHY, METRICS, COLORS, BREAKPOINTS };
